import { createStore } from 'vuex'

import configModule from '@/store/configModule'
import userModule from '@/store/userModule'
import venueModule from '@/store/venueModule'
import reservationFormModule from '@/store/reservationFormModule'
import copilotModule from '@/store/copilotModule'
import ebitdataModule from '@/store/ebitdataModule'
import kioskModule from '@/store/kioskModule'
import globalModule from '@/store/globalModule'
import menuModule from '@/store/menuModule'
import translationModule from '@/store/translationModule'
import weWingmanModule from '@/store/weWingmanModule'
import tpvModule from '@/store/tpvModule'
import reservationModule from '@/store/reservationModule'
import accountingModule from '@/store/accountingModule'
import backendSyncModule from '@/store/backendSyncModule'
import configStyleModule from '@/store/configStyleModule'
import preparationAreaModule from '@/store/preparationAreaModule'
import voucherModule from '@/store/voucherModule'
import uiOverlayModule from '@/store/uiOverlayModule'

export default createStore({
	modules: {
		user: userModule,
		reservationForm: reservationFormModule,
		venue: venueModule,
		config: configModule,
		ebitdata: ebitdataModule,
		copilot: copilotModule,
		kiosk: kioskModule,
		global: globalModule,
		menu: menuModule,
		translation: translationModule,
		weWingman: weWingmanModule,
		tpv: tpvModule,
		reservation: reservationModule,
		accounting: accountingModule,
		backendSync: backendSyncModule,
		ui: configStyleModule,
		preparationArea: preparationAreaModule,
		voucher: voucherModule,
		uiOverlay: uiOverlayModule
	}
})
